module.exports = __webpack_public_path__ + "static/media/chest-armor.f1f52a3c.svg";